import { render, staticRenderFns } from "./print-card.vue?vue&type=template&id=4f8a5a6d"
import script from "./print-card.vue?vue&type=script&lang=js"
export * from "./print-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports